import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=fd7b71b0&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd7b71b0')) {
      api.createRecord('fd7b71b0', component.options)
    } else {
      api.reload('fd7b71b0', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=fd7b71b0&", function () {
      api.rerender('fd7b71b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/colorSelect/Panel.vue"
export default component.exports